module.exports = __webpack_public_path__ + "static/media/0335_Small.aa6bedd8.jpg";